// @flow
import React from 'react';

import OveflowedText from 'app/common/components/OveflowedText';
import { phoneTransforByCountryCode } from 'app/common/lib/phone';

import styles from './DeliveryPointLabelSchool.module.scss';;


type Props = {
  schoolName: string,
  personName: ?string,
  phone: ?string,
  code?: 'ru' | 'kz' | 'kg',
}

const DeliveryPointLabelSchool = ({ schoolName, personName, phone, code = 'ru' }: Props) => (
  <div className={styles.root}>
    <div className={styles.col1}>
      <OveflowedText>{schoolName}</OveflowedText>
      <OveflowedText className={styles.personName}>{personName}</OveflowedText>
    </div>
    <div className={styles.phone}>{phone && phoneTransforByCountryCode(phone, code)}</div>
  </div>
);

export default DeliveryPointLabelSchool;
